import { render, staticRenderFns } from "./modalEditOptIns.vue?vue&type=template&id=57591fda&"
import script from "./modalEditOptIns.vue?vue&type=script&lang=js&"
export * from "./modalEditOptIns.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports